<template>
  <transition
    name="page"
    mode="out-in"
    @after-leave="$root.$emit('triggerScroll')"
  >
    <div class="flex flex-col justify-center items-center w-full h-full">
      <img
        src="/storage/image/heart.png"
        alt="Logo"
        class="w-16 mb-4"
      >
    </div>
  </transition>
</template>

<script>
export default {
  metaInfo: {
    title: process.env.MIX_PAGE_TITLE,
    titleTemplate: "%s | Home"
  }
};
</script>
